import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step, { stepClasses } from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import { colours } from "../StyleConstants";
import { StepConnector, stepConnectorClasses } from "@mui/material";
import styled from "@emotion/styled";

type LassoStepperProps = {
    clickHandler?: (index: number) => void;
    activeStep: number;
    stepLabels: string[];
    isDisabled?: boolean;
}

const CustomisedConnector = styled(StepConnector)(() => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
        top: 10,
        left: "calc(-50% + 12px)",
        right: "calc(50% + 12px)"
    },
    [`&.${stepConnectorClasses.active}`]: {
        borderColor: colours.orange.orange
    },
    [`&.${stepConnectorClasses.completed}`]: {
        borderColor: colours.orange.orange
    },
    [`&.${stepConnectorClasses.disabled}`]: {
        borderColor: colours.midnightBlue.blue40
    },
    "& .MuiStepConnector-line": {
        borderColor: "inherit",
        borderTopWidth: "4px",
        borderRadius: 1,
    }
}));

const LassoStepper = ({ clickHandler, activeStep, stepLabels, isDisabled }: LassoStepperProps) => {

    const handleClick = (index: number) => {
        if (clickHandler && !isDisabled) {
            clickHandler(index)
        }
    }

    const handleEnterPress = (e: React.KeyboardEvent, index: number) => {
        if(clickHandler && !isDisabled && e.key === 'Enter') {
            clickHandler(index)
        }
    }

    return (
        <Box sx={{ width: "100%" }}>
            <Stepper activeStep={activeStep}
                connector={<CustomisedConnector/>}
                alternativeLabel
            >
                {stepLabels.map((label, index) => {
                    return (
                        <Step key={label} index={index} aria-current={index === activeStep ? "step" : "false"}
                            active={activeStep === index}
                            tabIndex={clickHandler ? 0 : -1}
                            onClick={() => handleClick(index)}
                            onKeyDown={(e) => handleEnterPress(e, index)}
                            disabled={isDisabled}
                            sx={{
                                [`&.${stepClasses.root}`]: {
                                    padding: "0px",
                                },
                                cursor: "pointer",
                                pointerEvents: isDisabled ? 'none' : 'auto'
                            }}
                        >
                            <StepLabel
                                sx={{
                                    [`.MuiStepLabel-label.MuiStepLabel-alternativeLabel`]: {
                                        marginTop: "8px",
                                        fontWeight: "500",
                                        textTransform: "uppercase"
                                    },
                                    ".Mui-active": {
                                        color: colours.orange.orange
                                    },
                                    ".Mui-completed": {
                                        color: colours.orange.orange
                                    }
                                }}
                                StepIconProps={{
                                    sx: {
                                        "&.Mui-completed": {
                                            fill: colours.orange.orange,
                                            boxShadow: "none",
                                        },
                                        "&.Mui-active": {
                                            fill: colours.orange.orange,
                                            boxShadow: "none"
                                        },
                                        fill: "transparent",
                                        borderRadius: "100%",
                                        color: colours.midnightBlue.blue40,
                                        boxShadow: `0px 0px 0px 2px ${colours.midnightBlue.blue40}`,
                                        ".MuiStepIcon-text": {
                                            fill: colours.midnightBlue.blue40,
                                            fontSize: "14px",
                                            fontWeight: "500",
                                        },
                                        "&.Mui-completed > .MuiStepIcon-text": {
                                            fill: "white"
                                        },
                                        "&.Mui-active> .MuiStepIcon-text": {
                                            fill: "white"
                                        }
                                    }
                                }}
                            >
                                {label}
                            </StepLabel>
                        </Step>
                    );
                })}
            </Stepper>
        </Box>
    )
}

export default LassoStepper;